import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

const KnowMoreAboutShinzura = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Hide on refresh
  useEffect(() => {
    setIsVisible(false);
  }, []);

  return (
    <div className="w-full">
      {/* Clickable Box */}
      <div
        onClick={() => setIsVisible(!isVisible)}
        className="cursor-pointer bg-black shadow-md text-center text-sm text-gray-100 transition-all"
      >
        Know More About Shinzura
      </div>

      {/* Toggle Section */}
      {isVisible && (
        <div className="mt-1 bg-white p-6 shadow-lg space-y-4 text-gray-800 animate-fadeIn">
          <section>
            <h2 className="text-2xl font-bold text-pink-600 mb-2">
              Discover Skincare That Cares
            </h2>
            <p>
              Step into the world of Shinzura — where skincare meets soul care.
              Our mission is to offer luxurious, effective, and affordable skincare
              and beauty essentials tailored for Indian skin. From soothing cleansers
              to glow-boosting serums, we bring you products that work in harmony
              with your lifestyle and your skin.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-pink-500 mt-4">Shop by Category</h3>
            <ul className="list-disc ml-6">
              <li>Face Care: Cleansers, Moisturizers, Serums</li>
              <li>Makeup: Lipsticks, Foundations, Primers</li>
              <li>Haircare: Oils, Masks, Serums</li>
              <li>Wellness & Bodycare: Bath essentials, Body lotions, Scrubs</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-pink-500 mt-4">Why Choose Shinzura?</h3>
            <ul className="list-disc ml-6">
              <li>Made for Indian Skin</li>
              <li>Dermatologically Tested & Cruelty-Free</li>
              <li>Budget-Friendly Luxury</li>
              <li>Trendy Yet Effective</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-pink-500 mt-4">Our Promise</h3>
            <p>
              No parabens, no sulfates, no false claims. Just honest skincare
              that your skin will love. Whether you're starting out or
              leveling up your routine, Shinzura has something for everyone.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-pink-500 mt-4">People Also Search For</h3>
            <p>
            Shinzura is sometimes spelled or searched as Shinjura, Shingura, Shizuka, Shinzura, Shinjura, Shingura, Sinzura, Sinjura, Shinshura, Shinjira, Shinzora, Shinzira, Shinjula, Shinzuwa, Shinzuka, Shinzana, Shinzaya, Shinzuura, Shinzurra, Shizuka, Shijuka, Shinjika, Shinjikae, Shinzukae, Shinyura, Shiyura, Shijura, Zinzura, Shanzyra, Zinjura, Shinzara, Shinzula, Shynzura, Shynzara, Shynjura, Shinzore, Shinyura, Sinjika, Zinyura, Shinjuta, Shyura, Shyuzara. or Sinjura. No matter how you say it, we’re here to deliver high-performance skincare that works.
            </p>
          </section>
          <Helmet>
              <script type="application/ld+json">
                {`
                  {
                    "@context": "https://schema.org",
                    "@type": "Brand",
                    "name": "Shinzura",
                    "alternateName": ["Shinjura", "Shizuka", "Shijuka", "Shingura", "Sinjura", "Shinzuka"]
                  }
                `}
              </script>
            </Helmet>
        </div>
      )}
    </div>
  );
};

export default KnowMoreAboutShinzura;
